import { LOG } from '@/etc/log'

export default {
  methods: {
    $$log(msg, ...data) {
      const n = this._.type.name
      const log = LOG.m(n)
      log.log(msg, ...data)
    },
    $$info(msg, ...data) {
      const n = this._.type.name
      const log = LOG.m(n)
      log.info(msg, ...data)
    },
    $$warn(msg, ...data) {
      const n = this._.type.name
      const log = LOG.m(n)
      log.warn(msg, ...data)
    },
    $$err(msg, ...data) {
      const n = this._.type.name
      const log = LOG.m(n)
      log.err(msg, ...data)
    },
    $$test(msg, ...data) {
      const n = this._.type.name
      const log = LOG.m(n)
      log.test(msg, ...data)
    },
    $$success(msg, ...data) {
      const n = this._.type.name
      const log = LOG.m(n)
      log.success(msg, ...data)
    },
    $$debug(msg, ...data) {
      const n = this._.type.name
      const log = LOG.m(n)
      log.debug(msg, ...data)
    }
  }
}
